
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 1.333a6.667 6.667 0 100 13.334A6.667 6.667 0 008 1.333zm-.77 9.545V7.826a.77.77 0 111.54 0v3.052a.77.77 0 11-1.54 0zM8 6.215a.926.926 0 110-1.852.926.926 0 010 1.852z"}})])
          )
        }
      }
    